import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
import "../styles/page-science.css";

const CTA_LABEL = "Begin a partnership";




/* ──────── nav ──────── */



/* ──────── science hero ──────── */

function ScienceHero() {
  return (
    <section className="page-hero" id="top" data-screen-label="01 Science hero">
      <div className="wrap">
        <span className="eyebrow">Applied science</span>
        <h1 className="page-hero-h">The science behind the <span className="accent ink">performance growth.</span></h1>
        <p className="page-hero-sub">High performance is not accidental. It is applied science. Our approach is grounded in three complementary disciplines that guide how we think, how we measure, and how we build the systems that perform.</p>
      </div>
    </section>);

}

/* ──────── science disciplines ──────── */

function Disciplines() {
  const items = [
  { n: "01", name: "Behavioural Science", slot: "sci-behavioural", img: "/assets/img/sci-behavioural.png",
    tag: "Understanding human decision-making.",
    body: "Every click represents a human decision. People decide who to trust and what to risk in seconds, and rarely on logic alone. We read those decisions closely and design for how people actually think, so the intent we capture is real. The result is fewer empty clicks and more of the people you actually want." },
  { n: "02", name: "Data Science", slot: "sci-data", img: "/assets/img/sci-data.png",
    tag: "Measuring and modelling performance.",
    body: "Performance without measurement is guesswork. We work with our own data, enriched well beyond standard marketing data over years, and run analysis across all of it to identify patterns and trends that matter. From conversion signals to lead quality, our decisions are grounded in evidence, not assumption." },
  { n: "03", name: "Conversion Science", slot: "sci-conversion", img: "/assets/img/sci-conversion.png",
    tag: "Building scalable systems that convert.",
    body: "Insight and data only create value when engineered properly. We build on conversion-first design frameworks, then prove every decision through controlled experimentation. What we build is modular by design, ready to scale as your goals grow, and engineered around one outcome that matters: your profitability." }];


  return (
    <section className="disc" id="disc-current" data-screen-label="02 Disciplines">
      <div className="wrap">
        <div className="disc-head">
          <div>
            <span className="eyebrow">Three disciplines</span>
          </div>
          <div>
            <h2>Three disciplines, <span className="accent ink">working as one.</span></h2>
          </div>
        </div>
        <div className="disc-list">
          {items.map((it, i) =>
          <div className="disc-row" key={i}>
              <div className="disc-visual">
                <img className="disc-img" src={it.img} alt={it.name} />
              </div>
              <div className="disc-text">
                <span className="disc-num"><b>{it.n}</b></span>
                <h3 className="disc-name">{it.name}</h3>
                <span className="disc-tag">{it.tag}</span>
                <p className="disc-body">{it.body}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}

/* ──────── science AI statement ──────── */

function AiStatement() {
  return (
    <section className="ai-statement" data-screen-label="03 AI statement">
      <div className="wrap">
        <div className="ai-quote-wrap">
          <span className="eyebrow">Science + AI</span>
          <h2 className="ai-quote">We combine scientific thinking with AI-powered execution to unlock <span className="accent">better performance.</span></h2>
          <p className="ai-sub">Millions of proprietary data points, our science, and AI, guided by the team who built the thinking behind them.</p>
        </div>
      </div>
    </section>);

}

/* ──────── science closing ──────── */

function ScienceClosing({ ctaLabel, onCta }) {
  return (
    <section className="closing" data-tone="dark" data-screen-label="04 Closing CTA">
      <div className="wrap">
        <div className="closing-grid">
          <div>
            <span className="eyebrow">Next step</span>
          </div>
          <div>
            <h2>Start the <em>conversation.</em></h2>
            <p className="closing-side" style={{ marginTop: 28 }}>
              The thinking is ours. The results are yours. Let's talk about putting it to work.
            </p>
            <div className="closing-foot">
              <button className="link-btn-primary" onClick={onCta}>
                {ctaLabel} <span className="arrow">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

}

/* ──────── footer ──────── */

function SciencePage() {
  const [csOpen, setCsOpen] = useState(false);

  useEffect(() => {document.body.setAttribute("data-density", "standard");}, []);

  const openCs = (e) => {if (e) e.preventDefault();setCsOpen(true);};

  return (
    <div className="page page-science">
      <Nav onCta={openCs} ctaLabel={CTA_LABEL} />
      <ScienceHero />
      <Disciplines />
      <AiStatement />
      <ScienceClosing ctaLabel={CTA_LABEL} onCta={openCs} />
      <Footer onContact={openCs} />

      <ContactModal open={csOpen} onClose={() => setCsOpen(false)} />
    </div>);

}

export default SciencePage;
